import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Form, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import { getMatchesPublicByFilter } from '../../../actions/filtersActions'

export default function SearchMatches({ancho, filters = null, club = null}){
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const [filterOptions, setFilterOptions] = useState({host: '', visitor: '', date: '', club: club || null})

    useEffect(() => {
        if (filters) {
            setFilterOptions(filters)
            dispatch(getMatchesPublicByFilter(filters))
        }
    }, [filters, dispatch])

    useEffect(() => {
        if (club) {
            setFilterOptions((prev) => ({ ...prev, club }))
            dispatch(getMatchesPublicByFilter({ host: '', visitor: '', date: '', club }))
        }
    }, [club, dispatch])

    const handleInputChange = ({target})=>{
        setFilterOptions({
            ...filterOptions,
            [target.name]: target.value
        })
    }

    const searchMatches = () => {
        dispatch(getMatchesPublicByFilter(filterOptions))
    }

    const clearSearch = () => {
        const cleanedFilters = {host: '', visitor: '', date: '', club: club || null}
        setFilterOptions(cleanedFilters)
        dispatch(getMatchesPublicByFilter(cleanedFilters))
    }

    return (
        <Card.Body className='m-auto' style={{ width: ancho }}>
            <Row>
                <Col>
                    <Form.Group className='form-group'>
                        <Form.Control
                            type="text"
                            name="host"
                            onChange={handleInputChange}
                            value={filterOptions?.host}
                            placeholder={t('marketplace.hostSearch')}
                            required
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className='form-group'>
                        <Form.Control
                            type="text"
                            name="visitor"
                            onChange={handleInputChange}
                            value={filterOptions?.visitor}
                            placeholder={t('marketplace.visitorSearch')}
                            required
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className='form-group'>
                        <Form.Control
                            type="date"
                            name="date"
                            onChange={handleInputChange}
                            value={filterOptions?.date}
                            placeholder={t('marketplace.dateSearch')}
                            required
                        />
                    </Form.Group>
                </Col>
                <Col className='text-center d-flex align-items-center justify-content-around'>
                    <Button variant='secondary' type="submit" className="my-2 mx-1" onClick={() => searchMatches()}>
                        {t('marketplace.search')}
                    </Button>
                    {filterOptions.host || filterOptions.host || filterOptions.date ?
                        <div className="my-2 mx-1 cursor" onClick={() => clearSearch()}>
                            <img src="/images/trash.svg" alt="Limpiar" /> {t('marketplace.clearsearch')}
                        </div>
                    :
                        <></>
                    }
                </Col>
            </Row>
        </Card.Body>
    )
}